import { render, staticRenderFns } from "./RevenuesNfeImportPage.vue?vue&type=template&id=0b13ecf1&"
import script from "./RevenuesNfeImportPage.vue?vue&type=script&lang=js&"
export * from "./RevenuesNfeImportPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports